import * as S from './Text.style';

export const Text = () => {
  return (
    <S.Text>
      <S.Container>
        <h2>Termos e Condições Gerais de Uso - Olist Vnda</h2>
        <p>
          Esta Plataforma e todo o seu conteúdo são operados por e de propriedade da VNDA SERVIÇOS
          DE TECNOLOGIA DA INFORMAÇÃO LTDA. (&quot;Olist Vnda&quot;), CNPJ/ME 12.803.527/0001-33,
          com sede na rua Germano Petersen Júnior, 508, Sala 401, Porto Alegre, RS, CEP 90.540-140.
          Todos os direitos reservados. Estes Termos e Condições Gerais de Uso regem a utilização da
          plataforma disponível no site{' '}
          <a href="https://www.vnda.com.br/">https://www.vnda.com.br/</a>, que permite aos Usuários
          operacionalizar seus e-commerces e identificar oportunidades de crescimento no varejo. Os
          termos também se aplicam ao domínio do e-commerce disponibilizado.
        </p>
        <h3>CONSIDERAÇÕES PRELIMINARES</h3>
        <p>
          (i) Ao optar pelo uso da Plataforma, o Usuário concede aceitação total ao conteúdo do
          presente Termo de Uso e concorda que qualquer indivíduo que utilize sua conta em seu nome
          também o respeitará, incluindo futuras revisões, que a Plataforma tem o direito de fazer a
          qualquer momento.
        </p>
        <p>
          (ii) A{' '}
          <a href="https://olist.com/pt-br/seguranca-e-privacidade/politica-de-privacidade/?_gl=1*h27k2j*_ga*OTYxNTgwNDY3LjE3MTIwNzg5NzI.*_ga_5KP10GM2QT*MTcxMjY4MTc0MC43LjEuMTcxMjY4MTc0OS41MS4wLjA.">
            Política de Privacidade e Proteção de Dados
          </a>
          ,{' '}
          <a href="https://dnn65p9ixwrwn.cloudfront.net/uploads/2022/12/Codigo-de-Etica-e-Conduta-v.-3.0..pdf">
            Código de Ética e Conduta
          </a>{' '}
          e Proposta Comercial complementam e integram o presente Termo de Uso.
        </p>
        <p>
          (iii) Em caso de identificação de violação ou suspeita de violação do Código,
          disponibiliza-se o{' '}
          <a href="https://canal.ouvidordigital.com.br/olist">
            Canal de Ética e Conduta do Grupo Olist
          </a>{' '}
          para denúncias.
        </p>
        <p>(iv) A Olist Vnda faz parte do grupo OLIST.</p>
        <h4>1. Objeto</h4>
        <p>
          1.1. O objeto deste Termo é a prestação dos serviços de acesso e licença de uso da
          Plataforma pela Olist Vnda. A Plataforma oferece uma série de recursos e funcionalidades
          (“Serviços”) a depender do plano contratado. Você pode encontrar a relação e descrição no
          link: <a href="https://www.vnda.com.br/plataforma">https://www.vnda.com.br/plataforma.</a>
        </p>
        <p>
          1.2. É possível contratar todos ou parte dos Serviços, que estarão discriminados na
          Proposta Comercial, assim como o plano, prazo e formas de pagamento.
        </p>
        <h4>2. Pagamento do Serviços</h4>
        <p>
          2.1. Os valores do serviço de Plataforma de ecommerce oferecidos podem ser encontrados na
          Proposta Comercial. A Olist Vnda reserva-se o direito de realizar alterações de condições
          da proposta, como valores, forma e data de vencimento dos pagamentos, os quais serão
          previamente informados, com antecedência mínima de 30 (trinta) dias.{' '}
        </p>
        <p className="s">
          2.1.2. A comissão será calculada somente sobre o valor de pedidos com status confirmados
          no painel administrativo, contabilizado mês a mês.
        </p>
        <p className="s">
          2.1.3. Comissão é o percentual de cobrança sobre o total dos pedidos confirmados de cada
          Usuário, sendo esse percentual acordado na assinatura da proposta, podendo variar entre
          planos.{' '}
        </p>
        <p className="s">
          2.1.4. Os valores mencionados serão ajustados anualmente de acordo com o acumulado do
          índice IGPM. Alternativamente, caso o índice seja negativo, poderá ser utilizado o IPCA, a
          critério da Olist Vnda.
        </p>
        <p>
          2.2. Os Planos concedem acesso às funcionalidades conforme descrito no plano escolhido
          durante a contratação.
        </p>
        <p>
          2.3. Os valores para o serviço de Setup são individualizados e constam na Proposta
          Comercial.
        </p>
        <p className="s">
          2.3.1.Os serviços de Setup devem ser concluídos no prazo de um ano, a partir do aceite da
          Proposta. Caso não sejam finalizados dentro deste período por falta de entrega de
          informações ou tarefas do Usuário, os valores da Proposta Comercial estarão sujeitos a
          renegociação.
        </p>
        <p className="s">
          2.3.2. Compreende-se como Setup o processo abrangente que envolve várias etapas e
          atividades necessárias para a configuração e início das operações, de responsabilidades
          tanto do Usuário quanto da Plataforma. O setup inclui, mas não se limita ao: Planejamento
          Inicial, Design e Desenvolvimento do Site, Configuração de Infraestrutura Técnica, Gestão
          de Produtos, etc..
        </p>
        <p>
          2.4. O atraso no pagamento ensejará aplicação de multa de 10% (dez por cento) e juros de
          1% (um por cento) ao mês até o adimplemento.
        </p>
        <p>2.5. Os seguintes recursos não são contemplados nos serviços da Plataforma: </p>
        <ol>
          <li>(i) A conversão, exportação ou importação de dados de/para outros sistemas;</li>
          <li>
            (ii) Inserção de dados, textos e/ou outras informações (produtos, fotos e banners) que
            possam ser inseridas através do &quot;Painel Administrativo&quot;;{' '}
          </li>
          <li>
            (iii) SEO (Search Engine Optimization) serviço de otimização do site para buscadores.
          </li>
        </ol>
        <p>2.6. Os seguintes recursos ou serviços não são contemplados nos serviços de Setup:</p>
        <ol>
          <li>(i) Aquisição do domínio; </li>
          <li>(ii) Criação de contas de e-mail junto ao provedor de hospedagem; </li>
          <li>
            (iii) Suporte e adaptação de funcionalidades para os navegadores: Internet Explorer;
            Edge - anterior a versão 17; Firefox - anterior a versão 45; Safari - anterior a versão
            10.2; Opera - anterior a da versão 41; Chrome - anterior a versão 50{' '}
          </li>
          <li>
            (iv) Adaptação de funcionalidades que não funcionem corretamente em navegadores que
            sejam lançados após a data de assinatura do contrato;{' '}
          </li>
          <li>(v) Redação, tradução ou adaptação de textos e conteúdos; </li>
          <li>(vi) Aquisição de imagens ou contratação de fotógrafos; </li>
          <li>(vii) Treinamento avançado para utilização de editor HTML; </li>
          <li>(viii)Importação de dados de sistemas legados; </li>
          <li>(ix) Contratação de formas de pagamento junto aos bancos e operadoras;</li>
        </ol>
        <h4>3. Vigência e Cancelamento</h4>
        <p>
          3.1. A vigência dos planos terá tempo indeterminado, iniciando-se a partir da data
          indicada na proposta assinada.
        </p>
        <p>
          3.2. O Usuário poderá manifestar o interesse em rescindir o contrato mediante aviso
          prévio, com antecedência mínima de 30 (trinta) dias.
        </p>
        <p>
          3.3. Caso o contrato seja encerrado pelo Usuário antes da vigência acordada na Proposta,
          será aplicada uma multa correspondente ao valor de 3 (três) mensalidades vigentes à época
          da rescisão.
        </p>
        <p>
          3.4. Caso o Usuário opte por cancelar o serviço durante o Setup, o pagamento integral do
          Setup será devido. Isso porque são despendidos recursos, mão de obra e custos com
          ferramentas desde a contratação.
        </p>
        <p>
          3.5. Em caso de cancelamento por parte da Olist Vnda, o valor total do Setup será
          reembolsado ao Usuário.
        </p>
        <p>
          3.6. Em caso de solicitação de descontinuidade dos serviços pelo Usuário, as pendências
          financeiras deverão ser quitadas dentro do prazo máximo de 10 (dez) dias úteis, a contar
          do encerramento da loja. O não cumprimento desse prazo sujeitará o Usuário às medidas
          legais, incluindo o protesto dos valores.
        </p>
        <p className="s">
          3.6.1. No bloqueio por inadimplemento, para retomar o acesso à Plataforma, o Usuário
          deverá quitar todas as parcelas em aberto.
        </p>
        <p>3.7. Os Serviços poderão ser rescindidos unilateralmente pela Plataforma, em caso de:</p>
        <ol>
          <li>(i) tratamento desrespeitoso por parte do Usuário.</li>
          <li>
            (ii) se houver indícios de uso dos Serviços para incitar ou cometer atividades ilegais.
          </li>
          <li>
            (ii) identificada má-fé, fraude, desvio de finalidade na utilização da Plataforma, não
            cumprimento dos Termos de Uso ou da legislação aplicável ou ao término da Proposta
            Comercial.
          </li>
        </ol>
        <p>
          3.8. Os Serviços poderão ser bloqueados, de forma temporária ou permanente, em caso de:
        </p>
        <ol>
          <li>(i) Transferência de Contas para terceiros, seja de forma onerosa ou gratuita,</li>
          <li>(ii) Usuário que possuir duas ou mais mensalidades em aberto.</li>
        </ol>
        <h4>4. Obrigações da Olist Vnda</h4>
        <p>
          4.1. São obrigações da Olist Vnda, além das demais previstas neste instrumento, na
          proposta comercial, na legislação aplicável e no anexo a este contrato:{' '}
        </p>
        <ol>
          <li>
            (i) Disponibilizar a Plataforma, envidando os melhores esforços para assegurar e
            desenvolver a qualidade, respeitando a privacidade e mantendo sigilo sobre as
            informações cadastrais fornecidas, inclusive login e senha, que só serão divulgados a
            terceiros por determinação judicial, ressalvadas as hipóteses previstas neste Contrato.
          </li>
          <li>
            (ii) Comunicar a interrupção da prestação do Serviço por ocasião de manutenções
            preventivas e/ou corretivas;{' '}
          </li>
          <li>
            (iii) Fornecer suporte básico para a utilização da Plataforma, disponibilizando
            atendimento pelo e-mail ajuda@vnda.com.br ou pelo chat dentro da Plataforma. Sendo que
            os prazos para atendimento dos chamados variam de acordo com o nível de criticidade.
            Conforme tabela abaixo:
          </li>
        </ol>

        <table>
          <tr>
            <th>Nível de Criticidade </th>
            <th>Descrição: Possibilidade de uso dos Serviços</th>
            <th>Tempo de atendimento (em horas úteis)</th>
          </tr>
          <tr>
            <td>Muito alta </td>
            <td>Não podem ser usados e não há paliativo (sistema inoperante)</td>
            <td>6 (seis) </td>
          </tr>
          <tr>
            <td>Alta</td>
            <td>Com restrições severas ou procedimento paliativo</td>
            <td>12 (doze) </td>
          </tr>
          <tr>
            <td>Média</td>
            <td>Com poucas restrições</td>
            <td>24 (vinte e quatro) </td>
          </tr>
          <tr>
            <td>Baixa</td>
            <td>Sem impacto na operação</td>
            <td>80 (oitenta) </td>
          </tr>
        </table>
        <p>
          4.2. O Usuário entende e reconhece que o tempo de atendimento constante na tabela acima,
          não se confunde com tempo de resolução, não sendo possível estipular um prazo para este
          último, tendo em vista que as demandas possuem níveis diversos de complexidade.
        </p>
        <p>
          4.3. A utilização do Serviço de Suporte não implicará em nenhum custo adicional ao preço
          determinado na Proposta Comercial. No entanto, não serão considerados como suporte e serão
          cobrados mediante orçamento prévio os seguintes serviços:{' '}
        </p>
        <ol>
          <li>
            (i) correções de erros decorrentes da operação do Usuário e uso indevido da Plataforma;
          </li>
          <li>(ii) atendimentos que exijam visitas pessoais aos Usuários;</li>
          <li>(iii) revisões de layout; </li>
          <li>(iv) recapacitação para o uso da Plataforma; e</li>
          <li>(v) adaptações específicas ao ambiente de informática e acesso do Usuário.</li>
        </ol>
        <h4>5. Obrigações do Usuário</h4>
        <p>
          5.1. São obrigações do Usuário, além das demais previstas neste instrumento, na proposta
          comercial, na legislação aplicável e no anexo a este contrato:{' '}
        </p>
        <ol>
          <li>(i) Pagar os valores devidos conforme a proposta aderida;</li>
          <li>(ii) Tratar a Olist Vnda e seus funcionários de forma respeitosa;</li>
          <li>
            (iii) Usar com segurança o login e senha de acesso, responsabilizando-se por todos os
            compromissos decorrentes desse uso, inclusive de outros Usuários habilitados;
          </li>
          <li>
            (iv) Utilizar a Plataforma somente para fins lícitos e conforme a legislação brasileira;
          </li>
          <li>(v) Não violar direitos legais de terceiros;</li>
          <li>(vi) Manter suas credenciais de acesso em sigilo;</li>
          <li>
            (vii) Não compartilhar sua conta com terceiros, sob pena de rescisão do contrato e
            eliminação das informações armazenadas;
          </li>
          <li>(viii) Fornecer dados verídicos no preenchimento das informações cadastrais;</li>
          <li>(ix) Informar à Olist Vnda quaisquer alterações cadastrais;</li>
          <li>
            (x) Comunicar imediatamente qualquer extravio ou alienação das informações de acesso;
          </li>
          <li>(xi) Reconhecer o e-mail fornecido como meio válido para receber comunicações;</li>
          <li>
            (xii) Autorizar a página inicial de acesso à Plataforma como meio válido para divulgação
            de assuntos relacionados ao serviço contratado.
          </li>
        </ol>
        <p>5.2. Na utilização da Plataforma, é terminantemente proibido:</p>
        <ol>
          <li>
            (i) Ceder, sublicenciar, vender, doar, alienar, alugar, distribuir, transmitir,
            transferir, copiar, modificar, ampliar, reduzir, adaptar, traduzir, descompilar,
            desmontar, executar engenharia reversa ou explorar economicamente a Plataforma e o
            Conteúdo da Olist Vnda, incluindo dados e informações disponibilizadas, para finalidades
            não previstas nestes Termos de Uso ou para criação/fornecimento de produtos ou serviços
            concorrentes;
          </li>
          <li>
            (ii) Disseminar ou instalar vírus ou qualquer código, arquivo ou software malicioso para
            interromper, destruir, acessar indevidamente, limitar ou interferir no funcionamento ou
            segurança da Plataforma, bem como de informações, dados e equipamentos, ou para qualquer
            finalidade ilícita;
          </li>
          <li>
            (iii) Usar e acessar a Plataforma ou o Conteúdo da Olist Vnda de forma que prejudique
            sua segurança, integridade, disponibilidade e/ou funcionamento normal;
          </li>
          <li>
            (iv) Acessar a Plataforma ou quaisquer dados nela contidos de maneira não autorizada;
          </li>
          <li>(v) Violar a privacidade de outros Usuários da Plataforma; e</li>
          <li>
            (vi) Praticar qualquer ato contrário à legislação vigente ou a estes Termos de Uso.
          </li>
        </ol>
        <p>
          5.3. O Usuário declara, por si e seus Representantes (sócios, acionistas, administradores,
          empregados, agentes, representantes), que:{' '}
        </p>
        <ol>
          <li>
            (i) Não pratica atos de corrupção, suborno ou qualquer pagamento ilegal, atuando
            conforme leis e regulamentos contra a corrupção e lavagem de dinheiro, incluindo a
            legislação brasileira (Leis nº 8.429/1992, 9.613/1998, 12.529/2011, 12.846/2013), FCPA
            (EUA), UK Bribery Act (Reino Unido), convenções internacionais e o Código de Ética do
            grupo Olist;
          </li>
          <li>
            (ii) Informará à Olist Vnda se algum Representante exerce ou exerceu função de
            Autoridade Pública ou têm relações familiares/próximas com Autoridades Públicas;
          </li>
          <li>
            (iii) Concorda que a Olist Vnda poderá auditar o Usuário e seus Representantes a
            qualquer momento, conforme a Política de Privacidade do grupo Olist, devendo garantir
            amplo e irrestrito acesso a documentos e locais pertinentes;
          </li>
          <li>
            (iv) Compromete-se a comunicar imediatamente a Olist Vnda sobre qualquer violação,
            suspeita de violação ou irregularidade contra a legislação aplicável sobre combate e
            prevenção à lavagem de dinheiro, financiamento do terrorismo e corrupção, podendo
            utilizar o Canal de Ética e Conduta do grupo Olist.
          </li>
          <li>
            (v) Está ciente de que a violação desta cláusula poderá acarretar a rescisão do contrato
            e interrupção dos Serviços pela Olist Vnda;{' '}
          </li>
        </ol>
        <h4>6. Serviços de Suporte </h4>
        <p>
          6.1. A Olist Vnda envidará seus melhores esforços para manter a estabilidade da
          Plataforma. No entanto, na prestação de serviços na área de sistemas computacionais e
          software, não há garantia integral de nível de serviço. Durante a vigência da relação, a
          Olist Vnda garante as seguintes condições:
        </p>
        <table>
          <tr>
            <th>Serviço</th>
            <th>Nível de Serviço “SLA”</th>
          </tr>
          <tr>
            <td>Interface</td>
            <td>96% (noventa e seis por cento)</td>
          </tr>
          <tr>
            <td>Painel Administrativo</td>
            <td>94% (noventa e quatro por cento)</td>
          </tr>
        </table>
        <p>
          6.1.1.O SLA é calculado pela relação de tempo indisponível da Interface em relação ao mês.
          Considera-se Indisponível quando a Interface não estiver acessível para os Usuários.
        </p>
        <p>
          6.1.2. Não devem ser consideradas nesse cálculo de Indisponibilidade situações geradas por
          ações de responsabilidade do Usuário ou terceiros designados por ele, como: erros nos
          Arquivos de Interface de HTML/CSS e JavaScript, erros de direcionamento de DNS e outros.{' '}
        </p>
        <p>
          6.2. A Plataforma poderá ser interrompida, sem que haja qualquer direito de indenização ou
          compensação ao Usuário, eventualmente para:{' '}
        </p>
        <ol>
          <li>
            (i) Manutenções técnicas e/ou operacionais que exijam o desligamento temporário do
            sistema ou que impossibilitem o acesso;
          </li>
          <li>(ii) Casos fortuitos ou de força maior;</li>
          <li>(iii) Ações de terceiros que impeçam a prestação;</li>
          <li>(iv) Falta de fornecimento de energia elétrica;</li>
          <li>(v) Interrupção ou suspensão da prestação dos serviços de telecomunicações;</li>
          <li>
            (vi) Ocorrências de falhas no sistema de transmissão e/ou roteamento no acesso à rede
            mundial de computadores;
          </li>
          <li>
            (vii) Interrupções, falhas e/ou suspensão do serviço de infraestrutura de nossos
            fornecedores de infraestrutura terceiros.
          </li>
        </ol>
        <p>
          6.3. A Olist Vnda não será responsável por danos decorrentes de interrupções relacionadas
          aos eventos previstos no item acima, ou daqueles em que não tenham concorrido
          exclusivamente para sua ocorrência.
        </p>
        <h4>7. Limitação de Responsabilidade</h4>
        <p>
          7.1. A Olist Vnda é isenta de qualquer responsabilidade por danos causados através da
          utilização da Plataforma por pessoas não autorizadas ou terceiros que não façam parte do
          quadro de funcionários do Usuário ou ainda casos de violação a direitos nos quais não
          exista sua culpa subjetiva.
        </p>
        <p>
          7.2. Nos casos em que a Olist Vnda for responsável por danos causados pela Plataforma, a
          indenização será limitada ao valor de 3 (três) mensalidades do plano contratado.{' '}
        </p>
        <p>
          7.3. A Olist Vnda não se responsabiliza por pagamentos errôneos feitos pelo Usuário a
          fornecedores, funcionários, agentes ou qualquer outra pessoa, incluindo pagamentos gerados
          pelo sistema, como impostos e comissões.
        </p>
        <h4>8. Propriedade Intelectual</h4>
        <p>
          8.1. Todo o conteúdo do website www.vnda.com.br é propriedade exclusiva da Olist Vnda e
          protegido pelas leis brasileiras de direito intelectual. É estritamente proibido o uso não
          autorizado, divulgação, publicação, distribuição, transmissão, compilação, alteração ou
          reprodução total ou parcial dos conteúdos, sujeitando o infrator a sanções legais.
        </p>
        <h4>9. Uso da Marca</h4>
        <p>
          9.1 O Usuário autoriza a divulgação de sua marca como Usuário da Plataforma no site, em
          anúncios nas várias mídias de mercado, reportagens, eventos, testemunhais, entre outras
          formas de divulgação.
        </p>
        <p>
          9.2. Caso o Usuário prefira não ter sua marca divulgada, este deverá enviar comunicado
          formal à Olist Vnda, que se comprometerá a não divulgar.
        </p>
        <h4>10. Confidencialidade</h4>
        <p>
          10.1. Todas as informações inseridas e transmitidas pela Plataforma são consideradas
          confidenciais e não podem ser divulgadas, exceto por ordem judicial.
        </p>
        <p>
          10.2. A Olist Vnda não é responsável por violações de dados causadas por funcionários
          autorizados pelo Usuário ou por ações criminosas de terceiros fora da previsibilidade
          técnica.
        </p>
        <h4>11. Disposições Gerais</h4>
        <p>11.1. A Olist Vnda pode alterar procedimentos técnicos sem aviso prévio.</p>
        <p>11.2. A falta de exercício de direitos não implica renúncia.</p>
        <p>
          11.3. A nulidade de uma cláusula não afeta as outras, mantendo o contrato em vigor se o
          equilíbrio contratual for mantido.
        </p>
        <p>
          11.4. As Partes elegem o Foro da cidade de Porto Alegre, capital do Estado do Rio Grande
          do Sul, para dirimir eventuais demandas.
        </p>

        <h3>ANEXO I - PROTEÇÃO DE DADOS </h3>
        <p>
          O presente Anexo de Proteção de Dados (“Anexo”) é parte integrante dos Termos de Uso da
          Vnda Serviços de Tecnologia da Informação Ltda., estabelecidos entre o Usuário e a Olist
          Vnda, entrando em vigor a partir de sua incorporação aos referidos termos. Este Anexo e os
          Termos de Uso da Olist Vnda constituem as diretrizes definitivas para o tratamento de
          dados pessoais na utilização da Plataforma. Qualquer instrução adicional fora do escopo
          deste documento requer acordo prévio por escrito entre as partes.
        </p>
        <p>
          Os termos deste Anexo podem ser alterados, sendo que o Usuário pode consultar a versão
          mais atual dos Termos de Uso em{' '}
          <a href="www.vnda.com.br/termos">www.vnda.com.br/termos</a>. Em conformidade com a Lei nº
          13.709/2018 (“Lei Geral de Proteção de Dados - LGPD”) e a Política de Privacidade e
          Proteção de Dados, a Olist Vnda e as empresas do grupo OLIST comprometem-se a proteger a
          privacidade e os dados pessoais dos Usuários.
        </p>
        <h4>1. DOS DADOS PESSOAIS SUJEITOS AO PRESENTE ANEXO</h4>
        <p>
          1.1 O Usuário poderá enviar Dados Pessoais ao usar a Plataforma, cuja extensão é
          determinada e controlada a seu exclusivo critério, podendo incluir, sem restrições, dados
          pessoais relativos às seguintes categorias de Titulares dos Dados:{' '}
        </p>
        <ol>
          <li>
            a) Contatos do Usuário, incluindo, mas não somente, Usuários finais, funcionários,
            prestadores de serviços, fornecedores e subcontratados. Os titulares de dados também
            poderão incluir pessoas físicas que tentarem se comunicar com os Usuários finais do
            Usuário ou transferir dados pessoais a eles.{' '}
          </li>
          <li>
            b) O Usuário poderá enviar à Plataforma dados pessoais para realizar o sistema de
            assinatura, podendo incluir, sem restrições, as seguintes categorias de Dados Pessoais:
            Informações de Contato, incluindo CPF, nome, telefone, e-mail e endereços.
          </li>
        </ol>
        <h4>2. OPERAÇÕES DE TRATAMENTO</h4>
        <p>
          2.1 Os dados pessoais serão tratados conforme o Termo de Uso da Olist Vnda incluindo seus
          anexos e estarão sujeitos às seguintes atividades de Tratamento:
        </p>
        <ol>
          <li>
            a) Armazenamento e outros Tratamentos necessários para prestar, manter e aperfeiçoar os
            serviços da Plataforma, como envio de e-mails e newsletter e/ou;
          </li>
          <li>
            b) Compartilhamento de dados pessoais com parceiros de divulgação ou outras empresas do
            grupo OLIST (controlador societário da Olist Vnda) quando necessário para prestar,
            manter e aperfeiçoar os serviços ofertados ao Usuário, inclusive para as finalidades
            dispostas nos Termos de Uso da Olist Vnda;
          </li>
        </ol>
        <p>
          2.2 Os serviços prestados permitem que o Usuário insira informações para processamento por
          meio do software fornecido como software as a service. Na medida em que estas informações
          possam conter Dados Pessoais, as Partes concordam expressamente que este instrumento se
          aplicará da seguinte maneira:{' '}
        </p>
        <ol>
          <li>
            a) O Usuário enquanto CONTROLADOR dos dados, é responsável por: (i) definir os objetivos
            do Processamento de Dados Pessoais, pela exatidão dos Dados Pessoais; informar os
            titulares dos dados sobre o processamento de Dados Pessoais, as bases legais,
            finalidades e as modalidades para o exercício de seus direitos; (ii) elaborar
            notificações (incluindo notificações de violação de proteção de dados) às autoridades de
            proteção de dados, se necessário;
          </li>
          <li>
            b) A Olist Vnda, enquanto OPERADORA, define os meios do Processamento e é responsável
            pela implementação das medidas de segurança norteadoras do presente instrumento.
          </li>
        </ol>
        <h4>3. OBRIGAÇÕES DO USUÁRIO </h4>
        <p>3.1 O Usuário será responsável por:</p>
        <ol>
          <li>
            (i) Definir a finalidade do Processamento de Dados Pessoais, para a legalidade da
            transferência de Dados Pessoais para a Olist Vnda e para legalidade do Processamento de
            Dados.
          </li>
          <li>
            (ii) Cumprir, e fazer com que seus colaboradores e Olist Vnda cumpram, com todas as suas
            obrigações sob as Leis de Proteção de Dados ao processar Dados Pessoais em conexão com
            os serviços.
          </li>
          <li>
            (iii) Ser o contato principal para os Titulares dos Dados exercerem seus direitos
            conforme a Legislação de Proteção de Dados aplicável.
          </li>
          <li>
            (iv) Manter a precisão, qualidade, legalidade e confiabilidade dos dados pessoais por
            ele coletados para o tratamento na Plataforma.
          </li>
          <li>(v) Avaliar os riscos resultantes do tratamento de dados pessoais.</li>
          <li>
            (vi) Conservar e manter os Registros de Processamento para os Controladores com respeito
            a todas as obrigações do Controlador atribuídas ao Usuário, na medida exigida pela lei.
          </li>
          <li>
            (vi) Fornecer as informações aos Titulares dos Dados sobre o processamento dos Dados
            Pessoais, conforme exigido pela Legislação de Proteção de Dados aplicável.
          </li>
          <li>
            (vii) Informar ao Titular dos Dados sobre a divisão de responsabilidade entre o
            Controlador e o Operador, bem como acerca da divisão de responsabilidades traçadas neste
            Anexo.
          </li>
          <li>
            (viii) Cumprir todas as obrigações de notificação de violação de Proteção de Dados
            resultantes dos requisitos de Proteção de Dados aplicáveis, seja aos titulares de dados,
            seja à Autoridade Nacional de Proteção de Dados. Quando imposta pela Lei de Proteção de
            Dados aplicável, o Usuário é responsável pela notificação da Violação da Proteção de
            Dados aos Titulares dos Dados e às Autoridades de Proteção de Dados.
          </li>
          <li>
            (ix) Informar à Olist Vnda, imediata e detalhadamente, sobre quaisquer erros ou
            irregularidades relacionadas às Leis de Proteção de Dados no Processamento de Dados
            Pessoais de que tenha conhecimento quando relacionadas ao tratamento de dados no
            ambiente de utilização da Plataforma.
          </li>
          <li>
            (x) Informar os titulares dos dados acerca de eventuais compartilhamentos de dados
            feitos pela Olist Vnda, conforme descritos neste documento, e por incluir o uso nos
            registros de processamento.
          </li>
          <li>
            (xi) Garantir a precisão, qualidade e legalidade dos dados pessoais coletados e
            inseridos na Plataforma e pelos meios que os adquire; bem como pelo enquadramento nas
            bases legais necessárias para tratamento e processamento dos dados; e por garantir que
            tem o direito de transferir ou fornecer acesso aos dados pessoais para a Olist Vnda para
            fins de tratamento conforme previsto nos Termos de Uso Olist Vnda e seus anexos.
          </li>
          <li>
            (xii) Informar imediatamente à Olist Vnda se não for capaz de cumprir suas
            responsabilidades previstas neste Anexo ou nas Leis de Proteção de Dados aplicáveis.
          </li>
        </ol>
        <p>
          3.2. O Usuário por meio deste anexo confirma e reconhece que, caso solicite à Olist Vnda a
          exclusão dos Dados Pessoais ou a restrição de seu tratamento, pode tornar impossível o
          fornecimento dos produtos ou dos serviços fornecidos ou contratados. A Olist Vnda
          notificará o Usuário sobre tal consequência antes da execução da solicitação.{' '}
        </p>
        <h4>4. OBRIGAÇÕES DA OLIST VNDA</h4>
        <ol>
          <li>
            (i) Definir os meios de tratamento de dados pessoais e fornecer informações sobre esses
            meios ao Usuário, especificamente para permitir que Usuário possa elaborar registros e
            informar aos Titulares dos Dados conforme exigido pela Legislação de Proteção de Dados
            aplicável.{' '}
          </li>
          <li>
            (ii) Coletar e processar os dados pessoais somente dentro da estrutura dos seus Termos
            de Uso e anexos e para melhorar e atualizar esses serviços, não sendo responsável pelo
            cumprimento de nenhuma Lei de Proteção de Dados aplicável ao Usuário ou ao setor dele
            que não seja geralmente aplicável à Olist Vnda.
          </li>
          <li>
            (iii) Reconhecer expressamente que deve processar os Dados Pessoais somente para o
            fornecimento dos serviços da Plataforma, bem como para a melhoria e atualização do
            referido software.
          </li>
          <li>
            (iv) Implementar medidas de segurança para o tratamento de dados pessoais no âmbito da
            Plataforma e tomar as medidas técnicas e organizativas apropriadas, destinadas a
            proteger os dados pessoais do Usuário contra uso indevido e perda, ou contra qualquer
            outra violação de proteção de dados, de acordo com as Leis de Proteção de Dados
            aplicáveis.
          </li>
          <li>
            (v) Informar ao Usuário, sem demora indevida, em caso de violação dos Dados Pessoais do
            Usuário descoberta pela Olist Vnda.{' '}
          </li>
        </ol>
        <p>
          4.2. A Olist Vnda poderá auxiliar, caso requisitada, o Usuário a fornecer todas as
          informações necessárias a que tenha acesso, a fim de permitir que o Usuário cumpra suas
          obrigações, em caso de violação de proteção de dados.{' '}
        </p>
        <p>
          4.3. Os dados pessoais tratados no âmbito da Plataforma são geralmente retidos até que a)
          sejam excluídos pelo Usuário ou pelos Usuários da Plataforma, ou b) um período de retenção
          tenha expirado.{' '}
        </p>
        <p>
          4.4. O Usuário não pode exigir a exclusão de Dados Pessoais, uma vez que uma Lei ou regras
          aplicáveis exijam que sejam mantidos. Quando a Olist Vnda precisar reter Dados Pessoais
          por tais razões, seu processamento será restrito pela Olist Vnda, ou terceiros por ela
          contratados, até que o período de retenção aplicável tenha expirado. Além disso, o
          tratamento dos Dados Pessoais será restrito em vez de excluir os Dados Pessoais, na
          extensão legalmente permitida pela Lei de Proteção de Dados aplicáveis, em particular, se
          a exclusão não for razoavelmente viável ou se for somente possível com um custo
          desproporcional devido ao tipo específico de armazenamento. O Usuário reconhece e aceita
          que algumas solicitações podem resultar em reivindicações de remuneração adicionais para a
          Olist Vnda. A Olist Vnda informará o Usuário antes de executar a solicitação.{' '}
        </p>
        <p>
          4.5 A Olist Vnda será responsável por atender às solicitações do Usuário para correção,
          exclusão, restrição e disponibilização de Dados Pessoais durante a vigência e no término
          do Contrato.{' '}
        </p>
        <p>
          4.6 Caso a Olist Vnda receba uma solicitação para o exercício de direitos de um Titular de
          Dados conforme a Lei de Proteção de Dados Aplicável, esta encaminhará essa solicitação ao
          Usuário, que a instruirá sem atrasos indevidos sobre como proceder. O Usuário reconhece
          que, em caso de conflito entre o Titular de Dados e o Usuário, a legislação aplicável pode
          forçar a Olist Vnda a atender à solicitação do Titular dos Dados com relação à objeção do
          Usuário. Olist Vnda, entretanto, não tomaria essa medida sem a devida consideração da
          situação legal juntamente com o Usuário.{' '}
        </p>
        <p>
          4.7 Ao observar que não pode tratar Dados Pessoais conforme as Instruções do Usuário
          devido a uma exigência prevista em qualquer lei aplicável, a Olist Vnda: (i) comunicará
          imediatamente o Usuário acerca de tal exigência legal obedecendo ao limite permitido pela
          lei aplicável; e (ii) quando necessário, interromperá todo o Tratamento (exceto o mero
          armazenamento e manutenção da segurança dos Dados Pessoais afetados), até o momento em que
          o Usuário emitir novas Instruções que possam ser cumpridas pela Olist Vnda. Caso a
          presente disposição seja invocada, a Olist Vnda não será responsabilizada perante o
          Usuário nos termos do Acordo por não prestar os Serviços de Assinatura aplicáveis devidos
          até o momento em que o Usuário emitir novas Instruções lícitas sobre o Tratamento.
        </p>
        <h4>5. SEGURANÇA</h4>
        <p>
          5.1 A Olist Vnda implementará e manterá medidas técnicas e organizacionais adequadas para
          proteger os dados pessoais. Não obstante alguma disposição em contrário, a Olist Vnda
          poderá modificar ou atualizar as Medidas de Segurança práticas a seu exclusivo critério,
          desde que tal modificação ou atualização não gere um prejuízo material à proteção
          oferecida a tais medidas.{' '}
        </p>
        <p>
          5.2 A Olist Vnda garante que adota os melhores níveis quanto a segurança na proteção dos
          referidos dados cadastrais do Usuário, tendo instalado os meios e medidas técnicas para
          tentar evitar a perda, mau uso, alteração, acesso não autorizado ou subtração indevida dos
          dados cadastrais recolhidos.{' '}
        </p>
        <p>
          5.3 O Usuário declara estar ciente de que as medidas de segurança relativas a Internet não
          são integralmente infalíveis; de modo que o Usuário reconhece que a Olist Vnda não é
          responsável por qualquer acesso indevido, atividade suspeita na conta do Usuário ou,
          ainda, pelas eventuais consequências e danos decorrentes da falha do Usuário em manter a
          confidencialidade da senha e/ou da falta ou atraso na comunicação à Olist Vnda referente a
          eventual acesso indevido ou uso não autorizado da senha do Usuário por terceiros;{' '}
        </p>
        <h4>6. SUBOPERADORES </h4>
        <p>
          6.1 O Usuário concorda que a Olist Vnda pode contratar sub operadores para tratar Dados
          Pessoais em nome do Usuário; tais como terceiros com os quais a Olist Vnda mantém relações
          de parceria comercial para suporte e manutenção de nossos serviços; bem como serviços de
          tecnologia como análise de dados e sistemas de autenticação.{' '}
        </p>
        <p>
          6.2 Ao contratar suboperadores, a Olist Vnda requererá a eles termos de proteção de dados
          aos sub operadores que garantam, no mínimo, o mesmo grau de proteção para os Dados
          Pessoais conforme o disposto no Acordo, observada a natureza dos serviços prestados por
          tais suboperadores.{' '}
        </p>
        <h4>7. TRANSFERÊNCIA DE DADOS</h4>
        <p>
          7.1 O Usuário concorda e reconhece que a Olist Vnda pode acessar e tratar Dados Pessoais
          em escala global conforme o necessário para prestar o serviço da Plataforma, e que, para
          tanto, dados pessoais serão transferidos e tratados pela Olist Vnda e em outras
          jurisdições em que os funcionários da Olist Vnda e sub operadores tenham operações. A
          Olist Vnda garantirá que tais transferências sejam feitas de acordo com as exigências de
          transferências internacionais contidas nas Leis de Proteção de Dados.{' '}
        </p>
        <h4>8. PEDIDOS DAS AUTORIDADES REGULATÓRIAS</h4>
        <p>
          8.1 Quando exigido por lei, ambas as Partes devem manter os registros dos Dados Pessoais
          processados para os propósitos destes dos Termos de Uso e seus anexos, cooperar e fornecer
          todas as informações necessárias para o cumprimento das obrigações acima e o dever de
          notificação sob a Lei de Proteção de Dados Aplicáveis.{' '}
        </p>
        <p>
          8.2 Se a Olist Vnda necessitar auxiliar ou ajudar o Usuário a cumprir as obrigações legais
          do Usuário perante a Autoridade Nacional de Proteção de Dados, o Usuário deverá reembolsar
          a Olist Vnda em relação a custos com despesas relativas a pagamento de honorários
          advocatícios e custos derivados de viagens e despesas da prestação de tal assistência.{' '}
        </p>
        <h4>9. RESPONSABILIDADE</h4>
        <p>
          9.1 A Olist Vnda e o Usuário deverão cumprir suas respectivas obrigações, conforme
          estabelecido nos Termos de Uso e seus anexos e na Lei de Proteção de Dados Aplicáveis.{' '}
        </p>
        <p>
          9.2 O Usuário terá total responsabilidade por qualquer violação de suas obrigações,
          conforme estabelecido nos itens acima.{' '}
        </p>
        <p>
          9.3 Uma vez que atua como o operador, a Olist Vnda somente será responsável pelos danos
          causados pelo processamento quando não cumprir com as obrigações da Lei de Proteção de
          Dados Aplicáveis dirigida aos operadores ou se ela tiver agido fora ou contrária às
          instruções legais do Usuário.
        </p>
        <p>
          9.4 Caso provada a responsabilidade da Olist Vnda, a indenização devida ao Usuário será
          limitada à quantia correspondente ao valor de 3 (três) mensalidades do plano contratado
          pelo Usuário. O Usuário declara estar de acordo com a presente cláusula de limitação
          quantitativa da responsabilidade da Olist Vnda.{' '}
        </p>
        <p>
          9.5 A Parte infratora estará isenta de responsabilidade se provar que não é de forma
          alguma responsável pelo evento que deu origem ao dano.
        </p>
        <h4>10. TRANSFERÊNCIAS INTERNACIONAIS</h4>
        <p>
          10.1 O Usuário fica ciente que a Olist Vnda hospeda a infraestrutura de seu produto em
          fornecedores de infraestrutura de multilocação terceirizados. A locação do backup e
          réplica encontram-se no Estado da Virginia, Estados Unidos.{' '}
        </p>
        <p>
          <strong>Histórico de versões: 22 de agosto de 2024</strong>
        </p>
      </S.Container>
    </S.Text>
  );
};
